import { Grid } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { ImageAndText } from '../../atoms/ImageAndText';
import { CHECKOUT_URLS, PRODUCT_CODE_MAPPING } from '../../config';
import { useMe } from '../../config/api/queries';
import { colors } from '../../utils/theme';
import { useGlobalState } from '../../utils/GlobalStateProvider';

export const SmartMultiHero = (): JSX.Element => {
  const me = useMe();
  const context = useGlobalState(true);

  const vitaminPrice = useMemo(() => {
    if (context.state.products.size > 0) {
      return context.state.products.get(PRODUCT_CODE_MAPPING.vitamins)?.price;
    }
  }, [context.state.products]);

  const scrollToNutrientsRef = useCallback(() => {
    const smartMultiFormulation = document.getElementById(
      'smart-multi-formulation'
    );

    if (smartMultiFormulation) {
      smartMultiFormulation.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <Grid
      item
      sx={{
        py: 12,
        borderBottom: `1px solid ${colors.greys.BORDER_GREY}`,
        px: { xs: 3, md: 0 },
      }}
    >
      <ImageAndText
        imgSrc="/images/smart-multi.png"
        imgAlt="Rootine multivitamin box"
        subtitle1="90 DAY SUPPLY"
        subtitle2={vitaminPrice ? `$${vitaminPrice.toFixed(2)}/MONTH` : ''}
        title={`Hi ${me?.data?.first_name}, thank you for taking our lifestyle assessment quiz! Based on your answers, we've outlined your custom formulation below.`}
        priceText={
          vitaminPrice ? `$${vitaminPrice?.toFixed(2).toString()}` : ''
        }
        primaryButton={{
          label: 'Buy now',
          url: CHECKOUT_URLS.vitamins.link,
          ariaLabel: 'Buy smart multivitamin now',
        }}
        secondaryButton={{
          label: 'View your Smart Multivitamin formulation',
          onClick: scrollToNutrientsRef,
          ariaLabel: 'View your Smart Multivitamin formulation',
        }}
      />
    </Grid>
  );
};
